export const tag = {
  fdType: "resource_tags_v2",
  field: "tag",
  name: "Tag",
};

export const platform = {
  field: "platformId",
  name: "Platform",
  fdType: "platform",
};

export const host = {
  field: "hosts",
  name: "Host",
  fdType: "hosts_v2",
};

export const instance = {
  fdType: "instances_v2",
  field: "servername",
  name: "Instance",
};

export const database = {
  fdType: "databases_v2",
  field: "databasename",
  name: "Database",
};

export const waitCategory = {
  fdType: "wait_categories_v2",
  field: "wait_category",
  name: "Wait Category",
};

export const waitType = {
  field: "wait_type",
  name: "Wait Type",
  fdType: "wait_types_v2",
};

export const connectionHost = {
  fdType: "connection_hosts_v2",
  field: "connectionHost",
  name: "Application Host",
};

export const login = {
  field: "login",
  name: "Login",
  fdType: "login_by_instance_v2",
};

export const program = {
  field: "program",
  name: "Program",
  fdType: "program_by_instance_v2",
};

export const objectType = {
  fdType: "sql_audit_object_types",
  field: "objectTypeCode",
  name: "Object Type",
};

export const eventType = {
  fdType: "sql_audit_event_types",
  field: "eventTypeCode",
  name: "Event Type",
};

export const eventCategory = {
  field: "eventCategoryName",
  name: "Audit Category",
  options: [
    "Configuration changes",
    "Access changes",
    "Security changes",
    "Policy changes",
    "Login activity",
  ].map((option) => ({
    name: option,
    value: option,
  })),
};

export const isDisabled = {
  field: "isDisabled",
  name: "Is Disabled",
  fdType: "yesno",
  singleSelection: 1,
};

export const isExpired = {
  field: "isExpired",
  name: "Is Expired",
  fdType: "yesno",
  singleSelection: 1,
};

export const hasWeakPassword = {
  field: "hasWeakPassword",
  name: "Is Weak Password",
  fdType: "yesno",
  singleSelection: 1,
};

export const blockerId = {
  field: "blockerid",
  name: "Blocker ID",
  fdType: "blocker_ids_v2",
};

export const deadlockId = {
  field: "deadlockgroupid",
  name: "Deadlock Group ID",
  fdType: "deadlock_groups_v2",
};

export const weekday = {
  fdType: "days",
  field: "DayOfWeek",
  name: "Weekday",
};

export const timeOfDay = {
  fdType: "time_frames",
  field: "TimeOfDay",
  name: "Time of Day",
};

export const table = {
  field: "table",
  name: "Table",
  fdType: "table",
};

export const compressed = {
  field: "compressiontype",
  name: "Compressed",
  options: ["Page", "Row", "None"].map((option) => ({
    name: option,
    value: option,
  })),
};

export const isUnique = {
  field: "isUnique",
  name: "Unique",
  fdType: "yesno",
  options: ["Yes", "No"].map((option) => ({
    name: option,
    value: option,
  })),
};

export const jobCategory = {
  fdType: "jobs_categories",
  field: "category",
  name: "Category",
};

export const jobName = {
  fdType: "jobs_list",
  field: "job_name",
  name: "Name",
};

export const efficiencyScore = {
  field: "queryEfficiencyClassification",
  name: "Efficiency",
  allowExclude: true,
  maxSelectedItems: 1,
};

export const edition = {
  field: "edition",
  name: "Edition",
  fdType: "database_editions_v2",
};

export const priority = {
  field: "impactTypeId",
  name: "Priority",
  options: [
    { name: "High", id: 3 },
    { name: "Medium", id: 2 },
    { name: "Low", id: 1 },
  ].map((option) => ({
    name: option.name,
    value: option.name,
    id: option.id,
  })),
  allowExclude: false,
};

export const owner = {
  field: "ownerId",
  name: "Owner",
  fdType: "findingOwners",
  allowExclude: false,
};

export const status = {
  field: "statusTypeId",
  name: "Status",
  fdType: "finding_statuses",
  allowExclude: false,
};

export const compatibility = {
  field: "compatibilityLevel",
  name: "Compatibility Level",
};

export const recoveryModel = {
  field: "recoveryModel",
  name: "Recovery Model",
};

export const hostModel = {
  field: "hostModel",
  name: "Host Model",
};

export const os = {
  field: "operatingSystemTypeName",
  name: "OS",
  multiSelect: "or",
};

export const monitoringTypes = {
  field: "monitoringTypeName",
  name: "Monitoring",
  multiSelect: "or",
  fdType: "monitoringTypes",
};

export const dataCollector = {
  field: "collectorEnvironmentName",
  name: "Data Collector",
  fdType: "collectorEnvironments",
};

export const hasSilencingWindow = {
  field: "hasSilencingWindow",
  name: "Silencing Window",
  fdType: "yesno",
  singleSelection: 1,
};

export const alertCategory = {
  field: "alertCategoryTypeId",
  fdType: "alert_category_type",
  name: "Alert Category",
};

export const severity = {
  field: "alertSeverityTypeId",
  fdType: "alert_severity_type",
  name: "Severity",
};

export const alertName = {
  field: "alertName",
  fdType: "alert_types_v2",
  name: "Alert",
};

export const alertType = {
  field: "alertTypeId",
  fdType: "alert_types_v2",
  name: "Alert Type",
};

export const alertStatus = {
  field: "alertStatusType",
  // fdType: null,
  name: "Alert Status",
  options: [
    { display: "Open", name: "Open", value: "Open" },
    { display: "Closed", name: "Closed", value: "Closed" },
  ],
};

export const subscriptionStatus = {
  field: "status",
  name: "Account Status",
  fdType: "clientSubscriptionStatuses",
};

export const collectionStatus = {
  field: "collectionStatus",
  name: "Data Collection",
  fdType: "clientManagementTypes",
};

export const planType = {
  field: "planType",
  name: "Plan Type",
  fdType: "plan_types",
};

export const applicationType = {
  field: "applicationTypeName",
  name: "Application Type",
  fdType: "applicationTypes",
};

export const availability_instance = {
  field: "availability_instance",
  name: "AG Instance",
  fdType: "availability_groups_instances",
  // singleSelection: 1,
};

export const availability_databases = {
  field: "availability_databases",
  name: "AG Database",
  fdType: "availability_groups_instance_databases",
};

export const resources = {
  field: "resourceName",
  name: "Resources",
  fdType: "resources_v2",
};

export const profile = {
  field: "profile",
  name: "Profile",
  allowExclude: false,
};

export const memoryGrants = {
  field: "queryMemoryGrantRange",
  name: "Memory Grants",
  options: [
    {
      name: "5 ExtraLarge",
      value: "ExtraLarge",
      display: "ExtraLarge (2 GB+)",
    },
    {
      name: "4 Large",
      value: "Large",
      display: "Large (512 MB - 2 GB) ",
    },
    {
      name: "3 Medium",
      value: "Medium",
      display: "Medium (64 MB - 512 MB)",
    },
    {
      name: "2 Small",
      value: "Small",
      display: "Small (8 MB - 64 MB)",
    },
    {
      name: "1 Minimal",
      value: "Minimal",
      display: "Minimal (0 - 8 MB)",
    },
  ],
};

export const isPrimaryKey = {
  field: "isPrimaryKey",
  name: "Primary Key",
  fdType: "yesno",
};

export const indexType = {
  field: "indexType",
  name: "Index Type",
  options: ["Heap", "Clustered", "Nonclustered"].map((option) => ({
    name: option,
    value: option,
  })),
};

export const impactTypes = {
  field: "impactCategoryTypeId",
  name: "Impact",
  fdType: "impactTypes",
};

export const optimizationTypes = {
  field: "indexOptimizationTypeName",
  name: "Optimization Type",
  fdType: "optimizationTypes",
};

export const enabledJobs = {
  name: "Enabled Jobs",
  field: "isJobEnabled",
  allowExclude: false,
  fdType: "yesno",
};

export const failedJobs = {
  name: "Failed Jobs",
  field: "jobHasFailedExecution",
  allowExclude: false,
  fdType: "yesno",
};

export const collectors = {
  field: "collectorId",
  name: "Data Collector",
  fdType: "collectors_v2",
};

export const processName = {
  field: "processName",
  name: "Process Name",
  fdType: "process_v2",
};

export const processProgramName = {
  field: "processProgramName",
  name: "Program Name",
  fdType: "program_v2",
};

export const processManufacturerName = {
  field: "processManufacturerName",
  name: "Manufacturer Name",
  fdType: "manufacturer_v2",
};

export const processCategoryName = {
  field: "processCategoryName",
  name: "Category Name",
  fdType: "category_v2",
};

export const businessGoalTypes = {
  field: "businessGoalTypeId",
  name: "Business Goals",
  fdType: "business_goal_types",
};

export const effortTypes = {
  field: "effortTypeId",
  name: "Effort",
  fdType: "effort_types",
};

export const lastAccess = {
  field: "tableLastAccessCategoryType",
  name: "Last Access",
  options: ["Active", "Aging", "Stale", "Cold", "Frozen"].map((option: string, idx: number) => ({
    name: option,
    value: option,
    id: idx + 1,
  })),
};

export const queryObservationTypes = {
  field: "queryObservationTypeId",
  name: "Observations",
  fdType: "queryObservationTypes",
};

export const queryOptimizationStatus = {
  field: "queryOptimizationStatus",
  name: "Status",
  options: [
    {
      name: "Savings Found",
      value: "Savings Found",
      id: "ProcessedWithRecommendation",
    },
    {
      name: "Waiting",
      value: "Waiting",
      id: "Queued",
    },
    {
      name: "No savings",
      value: "No savings",
      id: "ProcessedWithNoRecommendation",
    },
    {
      name: "Not queued",
      value: "Not queued",
      id: "NotQueued",
    },
  ],
};

export const databaseSizeRange = {
  field: "databaseSizeRange",
  name: "Database Size",
  options: [
    {
      id: "Mb0To100",
      name: "Under 100 MB",
    },
    {
      id: "Mb100To1024",
      name: "100 MB - 1 GB",
    },
    {
      id: "Gb1To10",
      name: "1 GB - 10 GB",
    },
    {
      id: "Gb10To100",
      name: "10 GB - 100 GB",
    },
    {
      id: "Gb100To500",
      name: "100 GB - 500 GB",
    },
    {
      id: "GbGreaterThan500",
      name: "500 GB+",
    },
  ],
};

export const tableSizeRange = {
  field: "tableSizeRange",
  name: "Table Size",
  options: [
    {
      id: "Mb0To100",
      name: "Under 100 MB",
    },
    {
      id: "Mb100To1024",
      name: "100 MB - 1 GB",
    },
    {
      id: "Gb1To10",
      name: "1 GB - 10 GB",
    },
    {
      id: "Gb10To100",
      name: "10 GB - 100 GB",
    },
    {
      id: "Gb100To500",
      name: "100 GB - 500 GB",
    },
    {
      id: "GbGreaterThan500",
      name: "500 GB+",
    },
  ],
};

export const tableRowCountRange = {
  field: "tableRowCountRange",
  name: "Table Row Count",
  options: [
    { id: "Rows0To1000000", name: "0 – 1M rows" },
    { id: "Row1000000To10000000", name: "1M – 10M rows" },
    { id: "Rows10000000To500000000", name: "10M – 500M rows" },
    { id: "Rows500000000To1000000000", name: "500M – 1B rows" },
    { id: "Rows1000000000To10000000000", name: "1B – 10B rows" },
    { id: "RowsGreaterThan10000000000", name: "> 10B rows" },
  ],
};
